import React, { useState } from 'react';
import { X } from 'lucide-react';
import { assetsService } from '../../services';

interface CloneAssetModalProps {
  isOpen: boolean;
  onClose: () => void;
  assetId: string;
  assetName: string;
  onCloned: (newAssets: any[]) => void;
}

const CloneAssetModal: React.FC<CloneAssetModalProps> = ({ isOpen, onClose, assetId, assetName, onCloned }) => {
  const [count, setCount] = useState(2);
  const [namingPattern, setNamingPattern] = useState('{name} Copy {index}');
  const [zeroPadding, setZeroPadding] = useState(0);
  const [includeOriginal, setIncludeOriginal] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleClone = async () => {
    try {
      setSubmitting(true);
      const res = await assetsService.cloneAsset(assetId, {
        count,
        naming_pattern: namingPattern,
        zero_padding: zeroPadding,
        include_original: includeOriginal,
      } as any);
      const { original_asset, cloned_assets } = res as any;
      onCloned(cloned_assets);
      onClose();
    } catch (e) {
      console.error('Clone failed', e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: 520 }}>
        <div className="modal-header">
          <h2>Clone Asset</h2>
          <button className="close-button" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Asset</label>
            <input className="form-input" value={assetName} readOnly />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Number of clones</label>
              <input type="number" className="form-input" min={1} max={100} value={count} onChange={(e) => setCount(parseInt(e.target.value || '1', 10))} />
            </div>
            <div className="form-group">
              <label className="form-label">Zero padding</label>
              <input type="number" className="form-input" min={0} max={5} value={zeroPadding} onChange={(e) => setZeroPadding(parseInt(e.target.value || '0', 10))} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Naming pattern</label>
            <input className="form-input" value={namingPattern} onChange={(e) => setNamingPattern(e.target.value)} />
            <span className="helper-text">Use {'{name}'} and {'{index}'} placeholders. Example: "{assetName}-{'{index}'}"</span>
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={includeOriginal} onChange={(e) => setIncludeOriginal(e.target.checked)} />
            Also rename the original (index 0)
          </label>
        </div>
        <div className="modal-footer">
          <div className="footer-actions">
            <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" disabled={submitting} onClick={handleClone}>
              {submitting ? 'Cloning...' : 'Clone'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloneAssetModal;
